import { render } from "./RouteList.vue?vue&type=template&id=642b9b26"
import script from "./RouteList.vue?vue&type=script&lang=js"
export * from "./RouteList.vue?vue&type=script&lang=js"

import "./RouteList.vue?vue&type=style&index=0&id=642b9b26&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__